import styles from "./recentBlog.module.scss";
import logo from "../../assests/image.png";

export default function RecentBlog({ ...item }) {
  return (
    <div className={styles.container} id="blog">
      <div className={styles.wrapper}>
        <div className={styles.top}>
          <img className={styles.topImg} src={item.src} alt="img" />
        </div>
        <div className={styles.middle}>
          <h1 className={styles.title}>{item.title}</h1>
          <p className={styles.content}>{item.content}</p>
        </div>
        <div className={styles.bottom}>
          <div className={styles.bottomLeft}>
            <div className={styles.bottomImg}>
              <img className={styles.bImg} src={logo} alt="img" />
            </div>
            <div>
              <p>Jenny Wilson</p>
            </div>
          </div>
          <div className={styles.bottomRight}>
            <p>Jan 10, 2024</p>
          </div>
        </div>
      </div>
    </div>
  );
}
